import {StyleSheet} from 'react-native';
import { colorPalette, textStyles } from '../../../../../theme';

export default StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    borderRadius: 12,
    flexDirection: 'row',
    paddingVertical: 8.5,
    paddingHorizontal: 12,
    height : 72 , 
    alignItems: 'center',
    borderColor :'#EAEAEA' , 
    borderWidth : 1 , 
  },
  readyContainer : {
    borderRadius : 6 , 
    backgroundColor : '#F5FFF5' , 
    paddingHorizontal : 8,  
    paddingVertical : 2.5 
  },  
  vehicleContainer : {
    marginRight : 12 , 
    alignItems : 'center' , 
  },  
  priceWrapper: {
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
  },
  price: {
    fontFamily: textStyles.bold,
    fontSize: 16,
    color: colorPalette.grey9,
  },
  priceUnit: {
    fontFamily: textStyles.regular,
    fontSize: 14,
    color: colorPalette.grey7,
  },
  centerItem: {
    alignSelf: 'center',
  },
  infoWrapper: {
    flex: 1,
    alignSelf: 'stretch',
    alignItems: 'flex-end',
    justifyContent: 'center',
    paddingLeft: 8,
  },
  name: {
    fontSize: 14,
    fontFamily: textStyles.bold,
    color: colorPalette.grey9,
    textAlign: 'right',
  },
});
